module.exports = __webpack_public_path__ + "static/media/recreation.d7b28f88.jpg";